<template>
  <div>
  </div>
</template>

<script>
export default {
  name: 'Test',
  components: {
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {

  }

}
</script>

<style scoped lang='less'>
h1 {
  color: #fff;
}
</style>
